import React from 'react';

export const CollectListContext = React.createContext<any>(null);
export enum levelEnum {
  country = 1, // 全国视角
  province = 2, // 省视角
  city = 3, // 城市视角
  site = 4// 选址视角
}
export interface MapView{
  level:levelEnum|''
  provinceId?:number
  cityId?:number
  districtIds?:number[]
}
export const siteselectionmapbOperation = 'siteselectionmapbOperation';


/**
 * 品牌前六颜色范围
 */
export const BrandTop6ColorMap = {
  0: '#1E98FE',
  1: '#B8E7FF',
  2: '#FFD53A',
  3: '#21E5C6',
  4: '#A487F9',
  5: '#FFB9E0',
};

// 区以下聚合的临界条件
export const CLUSTER_CRITICAL_COUNT = 500;

export const leftListSelectionDOM = 'leftListSelectionDOM';

export enum tabsKey {
  energy = 'energy',
  all = 'all'
}

// 类名
export const mapCon = 'mapCon';
export const addBusiness = 'addBusinessBtn';
export const networkMapContainer = 'networkMapContainer';
export const topCon = 'topCon';

export enum leftTab{
  condition = '筛选点位',
  layer = '图层设置'
}

/**
 * @description 根据城市id寻找对应的城市信息
 * @param provincesCities store中的provincesCities数据
 * @param cityId 当前城市id
 * @returns 城市信息（附带所在省份部分数据）
 */
export const findCurCItyInfo = (provincesCities, cityId) => {
  let city;
  provincesCities?.forEach((province) => {
    province?.children?.forEach((item) => {
      if (item.id === cityId) {
        city = {
          ...item,
          provinceName: province?.name,
          provinceId: province?.id,
          pinyin: province?.pinyin
        };
      }
    });
  });
  return city;
};

// 缩放级别到17时，显示可视区域内所有的开店区域名称
export const showViewAreaNameZoom = 17;

export interface district {
  code:string;
  id:number;
  lat:string|number;
  lng:string|number;
  name:string;
}
export interface mapInfo{
  city:any;
  district:any;
  level:number;
}
// 当前选中的行政区信息
export interface curSelectDistrictType {
  districtInfo :district[];
  cacheMapInfo:mapInfo|null;
}

// 筛选项枚举
export enum sectionKey {
  sortRule = 'sortRule', // 排名规则
  sortRuleMenu = 'sortRuleMenu', // 排名规则
  firstLevelCategory='firstLevelCategory', // 开店区域类型
  categoryMenu = 'categoryMenu', // 开店区域类型
  secondLevelCategoryCultureEducation='secondLevelCategoryCultureEducation', // 文教型
  secondLevelCategoryCommunity='secondLevelCategoryCommunity', // 社区型
  secondLevelCategoryTraffic='secondLevelCategoryTraffic', // 交通枢纽型
  secondLevelCategoryStreet='secondLevelCategoryStreet', // 街铺商圈型
  secondLevelCategoryOffice='secondLevelCategoryOffice', // 办公型
  secondLevelCategoryBusiness='secondLevelCategoryBusiness', // 商场型
  secondLevelCategoryScenicSpot='secondLevelCategoryScenicSpot', // 景区型
  secondLevelCategoryCompound='secondLevelCategoryCompound', // 复合型
  area = 'area', // 行政区--no,
  districtMenu = 'districtMenu', // 行政区--no,
  labelSystemMall = 'labelSystemMall', // 开店区域标签
  labelSystemHighQuality = 'labelSystemHighQuality', // 商圈特性
  preferBrand='preferBrand',
  preferBrandMenu = 'preferBrandMenu', // 偏好品牌--no
  avoidBrand = 'avoidBrand', // 避开品牌--no
  avoidBrandMenu = 'avoidBrandMenu', // 避开品牌--no
  caseBrandMenu = 'caseBrandMenu', // 案例品牌--no
  caseBrand = 'caseBrand', // 案例品牌--no
  cateringStore = 'cateringStore', // 餐饮门店数
  oldCateringStore = 'oldCateringStore', // 餐饮老店占比
  population = 'population', // 周边人口
  marketScore = 'marketScore', // 市场评分
  marketScoreMenu = 'marketScoreMenu', // 市场评分
  passFlow = 'passFlow', // 商场日均客流指数
  housePrice = 'housePrice', // 周边房屋均价
  facility='facility', // 周边配套（500m）
  workType ='workType', // 办公
  schoolType = 'schoolType', // 学校
  trafficType='trafficType', // 交通
  scenicType='scenicType', // 景区
  medicalType ='medicalType', // 医院
  otherType = 'otherType', // 其他市场
  households = 'households', // 小区户数
  houseYear = 'houseYear', // 小区建筑年代
  tourBrand='tourBrand', // 巡展品牌
  tourBrandMenu='tourBrandMenu', // 巡展品牌
  developerBrand='developerBrand', // 开发商品牌
  labelSystemSource='labelSystemSource', // 来源
  brand='brand', // 本品牌门店
  competitorBrand='competitorBrand', // 竞品品牌
  famousBrand='famousBrand', // 知名品牌
}

export enum businessStatus {
  NEW = 'NEW',
  COMPLETE = 'COMPLETE'
}

/**
 * 全国视图下的颜色范围
 */
export const countryColorLevel = {
  1: '#007fff',
  2: '#5998FF',
  3: '#96BDFF',
  4: '#BBD3FB',
  5: '#E0EAFB',
  6: '#F2F2F2',
};
